module.exports = __webpack_public_path__ + "static/space-station.8859c227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/space-station.jpg
// module id = 135
// module chunks = 82267189633957 240366623535745